import { type FC } from 'react';
import { useIntl } from 'react-intl';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import HomeWorkOutlined from '@mui/icons-material/HomeWorkOutlined';

// screen
import StatCard from 'modules/dashboard/components/StatCard';
import type { MenuDishStatisticsResponse } from 'modules/dashboard/types';

interface Props {
  data?: MenuDishStatisticsResponse | null;
}

/**
 * Khối "NCC và HSNL NCC / Tổng năng lực cung ứng".
 * Số NCC/HSNL lấy từ KIOS (B2): tử = của trường, mẫu = tổng HVS, % = KIOS/tính sẵn.
 */
const SupplierCountCards: FC<Props> = ({ data }) => {
  const { formatMessage } = useIntl();
  const ncc = data?.ncc ?? null;

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600, mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <HomeWorkOutlined fontSize="small" />
        {formatMessage({ id: 'dashboard.supplier.sectionTitle' })}
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 2 }}>
        <StatCard
          label={formatMessage({ id: 'dashboard.supplier.nccCount' })}
          numerator={ncc?.ncc.value ?? null}
          denominator={ncc?.ncc.total ?? null}
          percent={ncc?.ncc.percent ?? null}
        />
        <StatCard
          label={formatMessage({ id: 'dashboard.supplier.hsnlCount' })}
          numerator={ncc?.hsnl.value ?? null}
          denominator={ncc?.hsnl.total ?? null}
          percent={ncc?.hsnl.percent ?? null}
        />
      </Box>
      {!ncc && (
        <Typography variant="caption" sx={{ color: 'text.disabled', mt: 0.5, display: 'block' }}>
          {formatMessage({ id: 'dashboard.supplier.pendingNote' })}
        </Typography>
      )}
    </Box>
  );
};

export default SupplierCountCards;
